module.exports = require('./src/fjGallery.esm').default;
